import { render, staticRenderFns } from "./riotGamesIcon.vue?vue&type=template&id=1c2f6f68&"
import script from "./riotGamesIcon.vue?vue&type=script&lang=js&"
export * from "./riotGamesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports